import {
  Menu,
  MenuButton,
  IconButton,
  Portal,
  MenuList,
  MenuItem,
  type MenuProps,
} from '@chakra-ui/react';
import { useNavigate } from '@tanstack/react-router';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '$/components/common/Icon';
import { useSchoolClassModal } from '$/pages/SchoolClassesPage/hooks/useSchoolClassModal';
import { type SchoolClass } from '$/services/usecases/school/mapper/schoolClasses';

interface Props extends Partial<MenuProps> {
  visible: boolean;
  schoolClass: SchoolClass;
}

export const SchoolClassContextMenu: FC<Props> = ({
  schoolClass,
  visible,
  ...menuProps
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const onOpenModal = useSchoolClassModal.useOnOpen();
  if (!visible) return null;

  return (
    <Menu {...menuProps} placement='bottom-end'>
      <MenuButton
        as={IconButton}
        layerStyle='floatCardButton'
        icon={<Icon boxSize='15px' color='text' icon='three_dots' />}
        onClick={(event) => {
          menuProps.onOpen?.();
          event.preventDefault();
          event.stopPropagation();
        }}
        variant='text'
      />
      <Portal>
        <MenuList fontSize='sm'>
          <MenuItem
            onClick={async (event) => {
              event.stopPropagation();
              await navigate({
                to: '/classes/$id',
                params: {
                  id: schoolClass.id,
                },
              });
            }}
          >
            {t('dashboard.projects.open')}
          </MenuItem>
          <MenuItem
            onClick={(event) => {
              event.stopPropagation();
              onOpenModal('renameClass', schoolClass);
            }}
          >
            {t('dashboard.projects.rename')}
          </MenuItem>
          <MenuItem
            onClick={(event) => {
              event.stopPropagation();
              onOpenModal('deleteClass', schoolClass);
            }}
          >
            {t('dashboard.projects.delete')}
          </MenuItem>
        </MenuList>
      </Portal>
    </Menu>
  );
};
